// extracted by mini-css-extract-plugin
module.exports = {"root":"buttonSecondary_root__1nQIO"};